/**
 * Sign in against better-auth. Two accounts exist, both seeded next to the repo;
 * this form knows nothing about them.
 *
 * Eén rustig kader, verticaal gecentreerd op een egale ondergrond die een halve
 * tint verschilt. Een haarfijne rand in plaats van een slagschaduw, echte labels
 * boven de velden, en één gevulde knop. Verder niets.
 */
import { type FormEvent, useState } from 'react';
import { foutBericht } from '@/lib/api/client';
import { useInloggen } from '@/lib/api/queries';
import { useZoekParams } from '@/lib/router';
import { veiligTerug } from '@/lib/terug';

export function Inloggen() {
  const [email, zetEmail] = useState('');
  const [wachtwoord, zetWachtwoord] = useState('');
  const [aangeraakt, zetAangeraakt] = useState(false);
  const inloggen = useInloggen();
  const terug = veiligTerug(useZoekParams().get('terug'));

  const emailLeeg = aangeraakt && email.trim() === '';
  const wachtwoordLeeg = aangeraakt && wachtwoord === '';

  function verstuur(event: FormEvent) {
    event.preventDefault();
    zetAangeraakt(true);
    if (email.trim() === '' || wachtwoord === '') return;
    inloggen.mutate({ email: email.trim(), wachtwoord });
  }

  return (
    <div className="flex h-full items-center justify-center bg-paper px-6">
      <form
        onSubmit={verstuur}
        noValidate={true}
        className="w-[352px] border border-line-strong bg-surface-strong px-8 py-9"
      >
        <h1 className="kop text-[24px]">MamiMap</h1>
        <p className="mt-1.5 text-[13px] text-muted">Analyse van de Amsterdamse koopwoningmarkt.</p>
        {terug ? (
          <p className="mt-3 text-[13px] text-ink-soft">
            Daarna ga je door naar {new URL(terug).hostname}.
          </p>
        ) : null}

        <div className="mt-7">
          <label className="veldnaam" htmlFor="email">
            E-mailadres
          </label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            aria-invalid={emailLeeg || undefined}
            aria-describedby={emailLeeg ? 'email-fout' : undefined}
            className="veld"
            value={email}
            onChange={(event) => zetEmail(event.target.value)}
          />
          {emailLeeg ? (
            <p id="email-fout" className="veldfout">
              Vul een e-mailadres in.
            </p>
          ) : null}
        </div>

        <div className="mt-4">
          <label className="veldnaam" htmlFor="wachtwoord">
            Wachtwoord
          </label>
          <input
            id="wachtwoord"
            type="password"
            autoComplete="current-password"
            aria-invalid={wachtwoordLeeg || undefined}
            aria-describedby={wachtwoordLeeg ? 'wachtwoord-fout' : undefined}
            className="veld"
            value={wachtwoord}
            onChange={(event) => zetWachtwoord(event.target.value)}
          />
          {wachtwoordLeeg ? (
            <p id="wachtwoord-fout" className="veldfout">
              Vul een wachtwoord in.
            </p>
          ) : null}
        </div>

        {/* Een mislukte inlog gaat over het paar, niet over één van de twee velden;
            hij staat er dus onder, in tekst, en niet als rood knipperend kader. */}
        {inloggen.error ? (
          <p className="veldfout mt-4" role="alert">
            {foutBericht(inloggen.error)}
          </p>
        ) : null}

        <button type="submit" className="knop mt-6 w-full" disabled={inloggen.isPending}>
          {inloggen.isPending ? 'Bezig met inloggen' : 'Inloggen'}
        </button>
      </form>
    </div>
  );
}
